module.exports = __webpack_public_path__ + "static/media/B2.708b6698.jpg";